/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useState, useRef } from "react";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Pagination from "@mui/material/Pagination";
import { Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import CloudDownload from "@mui/icons-material/CloudDownload";
import { withTranslation } from "react-i18next";
import classes from "./addons.module.css";

import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Tooltip from "@mui/material/Tooltip";
import Collapse from "@mui/material/Collapse";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import BlockIcon from "@mui/icons-material/Block";
import RestoreIcon from "@mui/icons-material/Restore";

import UpdateDialog from "./updateDialog";
import CancelDialog from "./cancelDialog";
import SuspendDialog from "./suspendDialog";
import ResumeDialog from "./resumeDialog";
import ChangeDialog from "./changeDialog";

import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import actionTypes from "../../../store/actions";
import { connect } from "react-redux";
import Loader from "../../../component/loader";
import SwapHorizontalCircleIcon from "@mui/icons-material/SwapHorizontalCircle";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import Draggable from "react-draggable";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../../../component/button";
import ManageCustomersHierarchy from "../manageCustomers/manageCustomersHierarchy";
import CustomerDetails from "../checkout/customerDetails/customerDetails";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import Input from "../../../component/inputpm";
import {
  SearchIcon,
  ClearIcon,
  ViewIconNew,
  EditIconNew,
  DeleteIconNew,
  EnterArrow,
} from "../../../component/icons/icons";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import TableContainer from "@mui/material/TableContainer";
// import { makeStyles } from '@mui/styles';

import { formatNumber } from "../../../helper/numberFormatter";

const AddonsTable = (props) => {
  console.log('=======', props)
  const t = props.t;
  const mainStyle = {
    maxWidth: "auto",
    margin: "auto",
    padding: "auto",
    paddingTop: "0",
    paddingRight: "0",
    backgroundColor: "transparent",
  };
  // const useStyles = makeStyles({
  //     resizablePaper: {
  //         resize: 'both',
  //         overflow: 'auto',
  //         minWidth: 640,
  //         minHeight: 200,
  //         maxWidth: '90vw',
  //         maxHeight: '90vh',
  //         width: '60vw',
  //     },
  // });

  const isSuspendable = (item) => {
    for (var i = 0; i < item.length; i++) {
      if (item[i].namedType === "suspendable") {
        return true;
      }
    }
  };

  const hasActivationParms = (item) => {
    for (var i = 0; i < item.length; i++) {
      if (item[i].namedType === "params" && item[i].namedId !== "[]") {
        return true;
      }
    }
  };

  const [loading, setLoading] = useState(false);
  console.log("props.addons", props.addons);

  const [cancelData, setCancelData] = useState({
    open: false,
    id: "",
    type: "",
  });
  const openCancelDialog = (id, type) => {
    setCancelData({
      open: true,
      id: id,
      type: type ? type : false,
    });
  };
  const closeCancelDialog = (val) => {
    if (val) {
      setLoading(true);
      BusApiCall(
        "PUT",
        `${constants.busV44UrlPublic}/assets/addons/${cancelData.id}/oprations/Cancel`,
      )
        .then((res) => {
          resetCancelDialog();
          if (res.data && res.data.message) {
            props.setErrorMessage(res.data.message, true);
          } else {
            props.setErrorMessage(
              props.t("ADDON_CANCELLED_SUCCESSFULLY"),
              true,
            );
          }
          setLoading(false);
          let data = {
            partyId: props.isChild
              ? props.childItemDetails.partyId
              : props.customerDetails.partyId,
          };
          props.getCustomerAddons(data);
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            props.setErrorMessage(err.response.data.message, false);
          } else {
            props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
          }
          resetCancelDialog();
          setLoading(false);
        });
    } else {
      resetCancelDialog();
    }
  };

  const resetCancelDialog = () => {
    setCancelData({
      open: false,
      id: "",
    });
  };

  const [changeData, setChangeData] = useState({
    open: false,
    item: {},
  });

  const openChangeDialog = (item) => {
    setChangeData({
      open: true,
      item: item,
    });
  };
  const closeChangeDialog = (val) => {
    if (val) {
      requestChangeSubscription(changeData.item);
    } else {
      resetChangeDialog();
    }
  };

  const resetChangeDialog = () => {
    setChangeData({
      open: false,
      item: {},
    });
  };

  const [suspendData, setSuspendData] = useState({
    open: false,
    id: "",
    action: "",
  });
  const openSuspendDialog = (id, action) => {
    setSuspendData({
      open: true,
      id: id,
      action: action,
    });
  };
  const closeSuspendDialog = (val) => {
    if (val) {
      if (suspendData.action === "CHANGE") {
        // open customer dailog
        setShowCustomerDialog(true);
      } else if (suspendData.action === "SHIFT") {
        setLoading(true);
        var paylod = {};
        BusApiCall(
          "PUT",
          `${constants.busV44UrlPublic}/subscriptions/${suspendData.id}/type/ShiftSubscription`,
          paylod,
        )
          .then((res) => {
            if (res.data && res.data.message) {
              props.setErrorMessage(res.data.message, true);
            } else {
              props.setErrorMessage(
                props.t("SHIFT_SUBSCRIPTION_SUCCESSFULLY"),
                true,
              );
            }
            resetSuspendDialog();
            setLoading(false);
            let data = {
              partyId: props.isChild
                ? props.childItemDetails.partyId
                : props.customerDetails.partyId,
            };
            props.getCustomerSubscriptions(data);
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              props.setErrorMessage(err.response.data.message, false);
            } else {
              props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
            }
            setLoading(false);
          });
      } else {
        setLoading(true);
        let data = { action: suspendData.action };
        BusApiCall(
          "PUT",
          `${constants.busV4Url}/subscriptions/${suspendData.id}`,
          data,
        )
          .then((res) => {
            props.setErrorMessage(
              props.t("SUBSCRIPTION_UPDATED_SUCCESSFULLY"),
              true,
            );
            setLoading(false);
            resetSuspendDialog();
            let customerData = {
              partyId: props.isChild
                ? props.childItemDetails.partyId
                : props.customerDetails.partyId,
            };
            props.getCustomerSubscriptions(customerData);
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              props.setErrorMessage(err.response.data.message, false);
            } else {
              props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
            }
            resetSuspendDialog();
            setLoading(false);
          });
      }
    } else {
      resetSuspendDialog();
    }
  };
  const resetSuspendDialog = () => {
    setSuspendData({
      open: false,
      id: "",
      action: "",
    });
  };
  const requestChangeSubscription = (item) => {
    var childItemDetails = props.childItemDetails ? props.childItemDetails : {};
    var customer = props.customerDetails;
    var obj = {
      ban: customer.ban,
      partyId:
        childItemDetails && childItemDetails.partyId
          ? childItemDetails.partyId
          : customer.partyId,
      customerId: customer.partyId,
      orderId: item.orderId,
      subscriptionId: item.id,
      firstName:
        childItemDetails && childItemDetails.partyId
          ? childItemDetails.firstName
          : customer.firstName,
      lastName:
        childItemDetails && childItemDetails.partyId
          ? childItemDetails.lastName
          : customer.lastName,
      role: customer.role,
      mode: "ChangeSubscription",
      productCode: item.productCode ? item.productCode : "",
      oldQuote: false,
      packageIndex: item.packageIndex,
      isAddon: true,
    };
    props.changeRoute(obj);
  };
  const [updateData, setUpdateData] = useState({
    id: "",
    variants: [],
    open: false,
  });
  const openUpdateComponentDialog = (id, variants) => {
    setUpdateData({
      id: id,
      variants: variants,
      open: true,
    });
  };
  const closeUpdateDialog = (val, newPlan) => {
    if (val) {
      setLoading(true);
      let data = { targetPlanId: newPlan };
      BusApiCall(
        "PUT",
        `${constants.busV4Url}/subscriptions/${updateData.id}`,
        data,
      )
        .then((res) => {
          props.setErrorMessage(props.t("UPDATE_SUBSCRIPTION_CREATED"), true);
          setLoading(false);
          resetUpdateData();
          let customerData = {
            partyId: props.isChild
              ? props.childItemDetails.partyId
              : props.customerDetails.partyId,
          };
          props.getCustomerSubscriptions(customerData);
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            props.setErrorMessage(err.response.data.message, false);
          } else {
            props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
          }
          setLoading(false);
          resetUpdateData();
        });
    } else {
      resetUpdateData();
    }
  };
  const resetUpdateData = () => {
    setUpdateData({
      id: "",
      variants: [],
      open: false,
    });
  };

  const [showCustomerDialog, setShowCustomerDialog] = useState(false);
  const [selectedTreeItems, changeSelectedTreeItems] = useState([]);
  const [customerDetails, setCustomerDetails] = useState({});
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);

  const selectCustomerClose = (
    currStage,
    data,
    selectedTreeItems,
    selectedPaymentMethod,
  ) => {
    setLoading(true);
    var subscriptionData = { ...suspendData };
    // setCustomerDetails(data);
    // changeSelectedTreeItems(selectedPaymentMethod);
    resetSuspendDialog();
    setShowCustomerDialog(false);
    var paylod = {
      partyId: data.partyId,
      customerId: data.ban,
    };
    BusApiCall(
      "PUT",
      `${constants.busV44UrlPublic}/subscriptions/${subscriptionData.id}/type/TakeoverSubscription`,
      paylod,
    )
      .then((res) => {
        if (res.data && res.data.message) {
          props.setErrorMessage(res.data.message, true);
        } else {
          props.setErrorMessage(
            props.t("TAKEOVER_SUBSCRIPTION_SUCCESSFULLY"),
            true,
          );
        }
        setLoading(false);
        let data = {
          partyId: props.isChild
            ? props.childItemDetails.partyId
            : props.customerDetails.partyId,
        };
        props.getCustomerSubscriptions(data);
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          props.setErrorMessage(err.response.data.message, false);
        } else {
          props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
        }
        setLoading(false);
      });
  };
  const closeDialog = () => {
    console.log("close dialog normally");
    resetSuspendDialog();
    setShowCustomerDialog(false);
    setCustomerDetails({});
    setSelectedPaymentMethod(null);
  };
  const resetSelecteddata = () => {
    console.log("reset selected data executed");
  };

  const [showNewCustomer, setShowNewCustomer] = useState(false);
  const [newCustomerDetails, setNewCustomerDetails] = useState({});

  const removeCustomerForm = () => {
    setShowNewCustomer(false);
    setShowCustomerDialog(true);
  };

  const closeErrorMessage = (error, type) => {
    props.setErrorMessage(error, type);
  };

  // This function is used to check new/update customer data
  const addCustomer = (data) => {
    setLoading(true);
    let contact = {
      ...data,
    };
    delete contact.billing;
    delete contact.shipping;
    delete contact.paymentInstrumentsMap;
    delete contact.paymentMethod;
    let banDetails = {
      accountName: data.accountName,
      ban: data.ban,
      partyId: data.partyId,
      label: data.label,
      value: data.ban,
    };
    let newData = {
      banDetails: banDetails,
      contact: contact,
      billing: data.billing,
      shipping: data.shipping,
      // paymentInstrumentsMap: data.paymentInstrumentsMap ? data.paymentInstrumentsMap : null
      paymentInstrumentsMap: null,
    };
    BusApiCall("POST", `${constants.busInternalUrl}/customers`, newData)
      .then((res) => {
        var tempData = {
          partyId: res.data.customer.partyId,
          ban: data.ban,
        };
        selectCustomerClose(null, tempData);
        setNewCustomerDetails({});
        setShowNewCustomer(false);
        // setLoading(false);
        var customer = {
          accountName: newData.banDetails.accountName,
        };
        props.setErrorMessage(
          this.props.t("CUSTOMER_CREATED_SUCCESSFULLY", { customer }),
          true,
        );
        if (data.paymentInstrumentsMap) {
          let paymentData = {
            contact: {
              firstName: newData.contact.firstName,
              lastName: newData.contact.lastName,
              partyId: res.data.customer.partyId,
              officePhone: newData.contact.officePhone,
              mobilePhone: newData.contact.mobilePhone,
              email: newData.contact.email,
              emailMechId: res.data.customer.emailMechId,
              mobilePhoneMechId: res.data.customer.mobilePhoneMechId,
              officePhoneMechId: res.data.customer.officePhoneMechId,
              billingCloseDay: newData.contact.billingCloseDay,
            },
            billing: {
              attention: "",
              phone: "",
              street1: "",
              street2: "",
              city: "",
              state: "",
              zip: "",
              country: "",
            },
            shipping: {
              attention: "",
              phone: "",
              street1: "",
              street2: "",
              city: "",
              state: "",
              zip: "",
              country: "",
            },
            banDetails: {
              accountName: data.accountName,
              ban: data.ban,
            },
          };
          if (data.paymentInstrumentsMap.creditCard) {
            let cardData = data.paymentInstrumentsMap.creditCard;
            let creditCard = {
              cardType: cardData.cardType,
              isPrimary: cardData.isPrimary,
              cardNumber: cardData.cardNumber,
              expireDate: cardData.expireDate,
              nameOnCard:
                cardData.firstNameOnCard + " " + cardData.lastNameOnCard,
              ...data.billing,
              billingContactMechId: res.data.customer.billing.postalMechId,
            };
            let payment = {
              creditCard: creditCard,
            };
            paymentData.paymentInstrumentsMap = payment;
          } else if (data.paymentInstrumentsMap.eftAccount) {
            let eftAccount = {
              ...data.paymentInstrumentsMap.eftAccount,
              ...data.billing,
              billingContactMechId: res.data.customer.billing.postalMechId,
            };
            let payment = {
              eftAccount: eftAccount,
            };
            paymentData.paymentInstrumentsMap = payment;
          }
          BusApiCall(
            "POST",
            `${constants.busInternalUrl}/customers`,
            paymentData,
          ).then((paymentRes) => {
            // props.setErrorMessage(props.t('CUSTOMER_CREATED_SUCCESSFULLY', { customer }), true);
          });
          // .catch(err => {
          //     if (err.response && err.response.data && err.response.data.message) {
          //         props.setErrorMessage(err.response.data.message, false)
          //     } else {
          //         props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
          //     }
          //     setLoading(false);
          // })
        }
      })
      .catch((err) => {
        setNewCustomerDetails({});
        setShowNewCustomer(false);
        if (err.response && err.response.data && err.response.data.message) {
          props.setErrorMessage(err.response.data.message, false);
        } else {
          props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
        }
        setLoading(true);
      });
  };
  // const classess = useStyles();
  return (
    <div style={{ width: "-webkit-fill-available" }}>
      <div>
        {/* <Grid container spacing={4}>
                    <Grid item xs={12}> */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            paddingLeft: props.screen === 'addonsManagement' && props.subScreen === 'listView' ? "0rem" : "1rem",
            paddingRight: props.screen === 'addonsManagement' && props.subScreen === 'listView' ? "0rem" : "1rem",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: props.screen === 'addonsManagement' && props.subScreen === 'listView' ? "0rem" : "1rem",
              flexWrap: "wrap",
            }}
          >
            {props.screen === 'addonsManagement' && props.subScreen === 'listView' ? '' : (
              <h3
                style={{
                  marginTop: "0",
                  marginBottom: "1rem",
                }}
              >
                {/* {t("SUBSCRIPTIONS")}:{" "} */}
                {props.isChild
                  ? props.childItemDetails.accountName ? props.childItemDetails.accountName : props.childItemDetails.name ? props.childItemDetails.name : ''
                  : props.customerDetails.accountName}
                {props.isChild ? '' : props.providerType === "SALES_CHNL_PROVIDER" ? ' (' + props.customerDetails.ban + ')' : ''}
                {/* {t('SUBSCRIPTIONS')}: {props.customerDetails.accountName} */}
              </h3>
            )}
            {/* <Paper className={'tablePaper'}> */}
            {/* <div className={classes.searchOuterDiv} style={{ flexWrap: "wrap", alignContent: "end", alignItems: 'center' }}> */}
            <div
              className={classes.searchOuterDiv}
              style={{
                marginBottom: ".5rem",
                width: "100%",
                alignItems: "center",
              }}
            >
              <div className={classes.searchInputDiv}>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("ADDON_NAME")}
                  value={props.filters?.productName}
                  name={"productName"}
                  onChange={(e) => {
                    props.onChangeAddonsFilters(e);
                  }}
                  divClass={classes.inputClass}
                  onKeyDown={(e) => {
                    props.onAddonsSearchKeyDownInput?.(e);
                  }}
                />
              </div>
              <div className={classes.searchInputDiv}>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("ADDON_ID")}
                  value={props.filters?.addonId}
                  name={"addonId"}
                  onChange={(e) => {
                    props.onChangeAddonsFilters(e);
                  }}
                  divClass={classes.inputClass}
                  onKeyDown={(e) => {
                    props.onAddonsSearchKeyDownInput?.(e);
                  }}
                />
              </div>
              <div className={classes.searchInputDiv}>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("ORDER_ID")}
                  value={props.filters?.orderId}
                  name={"orderId"}
                  onChange={(e) => {
                    props.onChangeAddonsFilters(e);
                  }}
                  divClass={classes.inputClass}
                  onKeyDown={(e) => {
                    props.onAddonsSearchKeyDownInput?.(e);
                  }}
                />
              </div>
              <div className={classes.searchInputDiv}>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("CUSTOMER_NAME")}
                  value={props.filters?.customerName}
                  name={"customerName"}
                  onChange={(e) => {
                    props.onChangeAddonsFilters(e);
                  }}
                  divClass={classes.inputClass}
                  onKeyDown={(e) => {
                    props.onAddonsSearchKeyDownInput?.(e);
                  }}
                />
              </div>
              <div
                className={classes.searchOrderLabelOuter}
                style={{ marginTop: ".25rem" }}
              >
                <div className={classes.searchOrderLabelInner}>
                  <Tooltip title={t("SEARCH")}>
                    <IconButton
                      className="iconButtonSecondary"
                      onClick={props.filterAddonsTable}
                    >
                      <SearchIcon />
                    </IconButton>
                  </Tooltip>{" "}
                  &nbsp;
                  <Tooltip title={t("CLEAR")}>
                    <IconButton
                      className="iconButtonSecondary"
                      onClick={props.clearAddonsFilters}
                    >
                      <ClearIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
          {props.data && props.data.length === 0 && !props.searchingAddons && (
            <Box
              className="roundCorners"
              style={{
                border: "1px solid lightgrey",
                padding: "1.5rem",
                marginTop: "1rem",
              }}
            >
              <Grid container spacing={2} align="center">
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                >
                  {t("ADDONS_NOT_FOUND")}
                </Grid>
              </Grid>
            </Box>
          )}
          {props.data && props.data.length > 0 && (
            <Card className="roundCorners" variant="outlined">
              {/* <Table className={'subscriptionTable newGlobalTable'}> */}
              <TableContainer>
                <Table className={"subscriptionTable newGlobalTable"}>
                  <TableHead>
                    <TableRow style={{ padding: 0 }}>
                      <TableCell
                        className="global-custom-sorting-header"
                        onClick={(e) => {
                          props.updateSorting("productName");
                        }}
                      >
                        <b>{props.t("ADDON_NAME")}</b>
                        {props.sortBy === "productName" ? (
                          <span className="material-icons">
                            {props.sortOrder === "DESC"
                              ? "expand_less"
                              : "expand_more"}
                          </span>
                        ) : (
                          <span className="material-icons sorting-indicator-icon">
                            unfold_more
                          </span>
                        )}
                      </TableCell>
                      <TableCell
                        className="global-custom-sorting-header"
                        onClick={(e) => {
                          props.updateSorting("nonInventoriedAssetId");
                        }}
                      >
                        <b>{props.t("ADDON_ID")}</b>
                        {props.sortBy === "nonInventoriedAssetId" ? (
                          <span className="material-icons">
                            {props.sortOrder === "DESC"
                              ? "expand_less"
                              : "expand_more"}
                          </span>
                        ) : (
                          <span className="material-icons sorting-indicator-icon">
                            unfold_more
                          </span>
                        )}
                      </TableCell>
                      <TableCell
                        onClick={(e) => {
                          props.updateSorting("orderId");
                        }}
                        className="global-custom-sorting-header"
                      >
                        <b>{props.t("ORDER_ID")}</b>
                        {props.sortBy === "orderId" ? (
                          <span className="material-icons">
                            {props.sortOrder === "DESC"
                              ? "expand_less"
                              : "expand_more"}
                          </span>
                        ) : (
                          <span className="material-icons sorting-indicator-icon">
                            unfold_more
                          </span>
                        )}
                      </TableCell>
                      {props.screen === 'addonsManagement' && props.subScreen === 'listView' &&
                        <TableCell>
                          <b>{props.t("CUSTOMER_NAME")}</b>
                        </TableCell>
                      }
                      <TableCell
                        className="global-custom-sorting-header"
                        style={{ verticalAlign: "bottom" }}
                      >
                        <b>{props.t("STATUS")}</b>
                        {/* {props.sortBy === 'statusId' ?
                                                    <span className="material-icons">
                                                        {props.sortOrder === 'DESC' ? 'expand_less' : 'expand_more'}
                                                    </span>
                                                    :
                                                    <span className="material-icons sorting-indicator-icon">
                                                        unfold_more
                                                    </span>
                                                } */}
                      </TableCell>
                      {props.providerType != "SOLUTION_PROVIDER" && (
                        <TableCell
                          style={{ maxWidth: "17%", verticalAlign: "bottom" }}
                          className="global-custom-sorting-header"
                        >
                          <b>{props.t("ACTION")}</b>
                        </TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {props.data &&
                      props.data.map((item, index) =>
                        item.productId ? (
                          <>
                            {/* <TableRow key={index} className={classes.subscriptionCustomTable}> */}
                            <TableRow key={index} className={"newGlobalTable"}>
                              {/* <TableCell>
                                                                <div style={{ display: 'flex' }}>
                                                                    <div>{item.productName}</div>
                                                                    <span style={{ marginLeft: ".25rem" }}>
                                                                        {item.additionalAttributes && hasActivationParms(item.additionalAttributes) && (
                                                                            <IconButton aria-label="expand row" size="small" onClick={() => props.openAddons(index)}>
                                                                                {item.expand ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                                            </IconButton>
                                                                        )}
                                                                    </span>
                                                                </div>
                                                            </TableCell> */}
                              <TableCell
                                style={{
                                  maxWidth: "auto",
                                  whiteSpace: props.isMobile
                                    ? "nowrap"
                                    : "normal",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {item.productName}
                                  {item.additionalAttributes &&
                                    hasActivationParms(
                                      item.additionalAttributes,
                                    ) && (
                                      <IconButton
                                        aria-label="expand row"
                                        size="small"
                                        onClick={() => props.openAddons(index)}
                                        style={{ marginLeft: ".25rem" }} // Space between the button and the product name
                                      >
                                        {item.expand ? (
                                          <KeyboardArrowUpIcon />
                                        ) : (
                                          <KeyboardArrowDownIcon />
                                        )}
                                      </IconButton>
                                    )}
                                </div>
                              </TableCell>

                              <TableCell
                                className="wordBreak"
                                style={{
                                  whiteSpace: props.isMobile
                                    ? "nowrap"
                                    : "normal",
                                }}
                              >
                                {item.id}
                              </TableCell>
                              <TableCell>{item.orderId}</TableCell>
                              {props.screen === 'addonsManagement' && props.subScreen === 'listView' &&
                                <TableCell>{item.customerName}</TableCell>
                              }
                              <TableCell>
                                {/* {item.status} */}
                                {item.status === "Active" ? (
                                  <Chip
                                    size="normal"
                                    className="successChip"
                                    label={item.status}
                                  />
                                ) : (
                                  <Chip
                                    size="normal"
                                    className="inProgressChip"
                                    label={item.status}
                                  />
                                )}
                              </TableCell>
                              {props.providerType != "SOLUTION_PROVIDER" && (
                                <TableCell>
                                  {/* {item.status === "Active" && props.quoteEnabled && props.userPerms.includes("CUMULATOR_SUBSCRIPTION_UPDATE") && (
                                                                    <>
                                                                    <Tooltip title={props.t("CHANGE_ADDON")}>
                                                                        <IconButton
                                                                            aria-label={props.t("CHANGE_ADDON")}
                                                                            className="buttonSecondary"
                                                                            onClick={() => {
                                                                                openChangeDialog(item);
                                                                            }}
                                                                        >
                                                                            <EditIconNew />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                    &nbsp;
                                                                    </>
                                                                )} */}

                                  {item.status === "Active" &&
                                    props.userPerms.includes(
                                      "CUMULATOR_SUBSCRIPTION_CANCEL",
                                    ) && (
                                      <>
                                        <Tooltip
                                          title={props.t("CANCEL_ADDON")}
                                        >
                                          <IconButton
                                            aria-label={props.t("CANCEL_ADDON")}
                                            className="buttonSecondary"
                                            onClick={() => {
                                              openCancelDialog(
                                                item.id,
                                                item.isCoreItem,
                                              );
                                            }}
                                          >
                                            <DeleteIconNew />
                                          </IconButton>
                                        </Tooltip>
                                        &nbsp;
                                      </>
                                    )}
                                  {item.status !== "Active" &&
                                    item.status !== "Suspended" &&
                                    item.operationId && (
                                      <>
                                        {item.operationType &&
                                          item.operationType === "order" ? (
                                          <Tooltip
                                            title={props.t("VIEW_ORDER")}
                                          >
                                            <IconButton
                                              className="buttonSecondary"
                                              aria-label={props.t("VIEW_ORDER")}
                                              onClick={() => {
                                                props.goToQuote(
                                                  item.operationId,
                                                  "order",
                                                );
                                              }}
                                            >
                                              <ViewIconNew />
                                            </IconButton>
                                          </Tooltip>
                                        ) : (
                                          <Tooltip
                                            title={props.t("VIEW_QUOTE")}
                                          >
                                            <IconButton
                                              className="buttonSecondary"
                                              aria-label={props.t("VIEW_QUOTE")}
                                              onClick={() => {
                                                props.goToQuote(
                                                  item.operationId,
                                                  "quote",
                                                );
                                              }}
                                            >
                                              <ViewIconNew />
                                            </IconButton>
                                          </Tooltip>
                                        )}
                                        &nbsp;
                                      </>
                                    )}
                                </TableCell>
                              )}
                            </TableRow>
                            {item.expand && (
                              <TableRow>
                                <TableCell
                                  colSpan={
                                    props.providerType != "SOLUTION_PROVIDER"
                                      ? 5
                                      : 5
                                  }
                                  className={
                                    "subscriptionTableCustomeCollapseCell"
                                  }
                                  style={{ border: "none" }}
                                >
                                  <Collapse
                                    in={item.expand}
                                    timeout="auto"
                                    style={{}}
                                  >
                                    <TableContainer>
                                      <Table>
                                        <TableBody>
                                          {item.additionalAttributes &&
                                            item.additionalAttributes.map(
                                              (component, c) =>
                                                component.namedType ===
                                                "params" && (
                                                  <React.Fragment key={c}>
                                                    {component.namedId &&
                                                      JSON.parse(
                                                        component.namedId,
                                                      ).length > 0 && (
                                                        <>
                                                          <>
                                                            {JSON.parse(
                                                              component.namedId,
                                                            ).map((param, p) => (
                                                              <TableRow>
                                                                <TableCell
                                                                  key={p}
                                                                >
                                                                  <span
                                                                    style={{
                                                                      display:
                                                                        "flex",
                                                                      alignItems:
                                                                        "center",
                                                                      gap: "1rem",
                                                                      paddingLeft:
                                                                        "40px",
                                                                    }}
                                                                  >
                                                                    <EnterArrow />
                                                                    {
                                                                      param.label
                                                                    }{" "}
                                                                    :{" "}
                                                                    {param.value}
                                                                  </span>
                                                                </TableCell>
                                                              </TableRow>
                                                            ))}
                                                          </>
                                                        </>
                                                      )}
                                                  </React.Fragment>
                                                ),
                                            )}
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  </Collapse>
                                </TableCell>
                              </TableRow>
                            )}
                          </>
                        ) : null,
                      )}
                    {props.data &&
                      props.data.length === 0 &&
                      !props.searchingAddons && (
                        <TableRow>
                          <TableCell align="center">
                            {t("ADDONS_NOT_FOUND")}
                          </TableCell>
                        </TableRow>
                      )}
                    {props.searchingAddons && (
                      <TableRow>
                        <TableCell align="center">{t("SEARCHING")}</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {props.totalAddonsCount > 0 && (
                <div
                  className="global-custom-pagination"
                  style={{ background: "rgba(196, 196, 196, 0.2)" }}
                >
                  <label style={{ float: "left", padding: "5px" }}>
                    {t("TOTAL_RECORDS")}: {formatNumber(props.totalAddonsCount)}
                  </label>
                  <label>
                    {/* Rows per page select */}
                    {t("ROWS_PER_PAGE")}:
                    <Select
                      value={props.addonsRowsPerPage}
                      onChange={props.updateAddonsRowsPerPage}
                    >
                      <MenuItem
                        value={10}
                        classes={{ root: "treeRowPerPageItem" }}
                      >
                        10
                      </MenuItem>
                      <MenuItem
                        value={50}
                        classes={{ root: "treeRowPerPageItem" }}
                      >
                        50
                      </MenuItem>
                      <MenuItem
                        value={100}
                        classes={{ root: "treeRowPerPageItem" }}
                      >
                        100
                      </MenuItem>
                    </Select>
                  </label>

                  {/* Pagination component */}
                  <Pagination
                    page={props.addonsPage}
                    count={Math.ceil(
                      props.totalAddonsCount / props.addonsRowsPerPage,
                    )}
                    onChange={props.changeAddonsPage}
                    siblingCount={props.isMobile ? 0 : 1}
                    boundaryCount={1}
                    showFirstButton={props.isMobile ? false : true}
                    showLastButton={props.isMobile ? false : true}
                  />
                </div>
              )}
            </Card>
          )}
        </div>
        {/* </Paper> */}
        {/* </Grid>
                </Grid> */}

        {/* Cancel LTE subscription dialog */}
        <CancelDialog
          isOpen={cancelData.open}
          close={closeCancelDialog}
          cancelData={cancelData}
        />

        <ChangeDialog
          isOpen={changeData.open}
          close={closeChangeDialog}
          data={changeData}
        />

        {/* Update LTE devices dialog */}
        <UpdateDialog
          isOpen={updateData.open}
          close={closeUpdateDialog}
          data={updateData}

        // solutionPlans={this.state.solutionPlans}
        // serviceInstanceId={this.state.selectedServiceInstanceId}
        // updateSubscription={this.updateSubscription}
        // details={this.state.details}
        // selectedPlan={this.state.selectedPlan}
        // firstLevelFeatureId={this.state.selectedFirstLevelFeatureId}

        // availableVariants={this.state.availableVariants}
        />

        {/* Suspend/Resume subscription dialog */}
        <SuspendDialog
          isOpen={suspendData.open}
          close={closeSuspendDialog}
          action={suspendData.action}
        />

        {showCustomerDialog && (
          <Dialog
            maxWidth={"lg"}
            PaperComponent={DraggableDialogPaper}
            fullWidth={true}
            open={showCustomerDialog}
            aria-labelledby="import-dialog-title"
          // PaperProps={{
          //     className: classess.resizablePaper
          // }}
          >
            <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
              {t("SELECT_CUSTOMER")}
              {props.providerType === "SALES_CHNL_PROVIDER" &&
                (props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                  props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
                  <Button
                    style={{ float: "right" }}
                    onClick={() => {
                      setShowCustomerDialog(false);
                      setShowNewCustomer(true);
                    }}
                  >
                    {t("ADD_CUSTOMER")}
                  </Button>
                )}
            </DialogTitle>
            <DialogContent dividers style={{ height: "550px" }}>
              <ManageCustomersHierarchy
                screen="checkout"
                subScreen="product"
                stage={0}
                next={selectCustomerClose}
                // back={this.back}
                selectedTreeItems={selectedTreeItems}
                customerDetails={customerDetails}
                selectedPaymentMethod={selectedPaymentMethod}
                resetSelecteddata={resetSelecteddata}
                closeDialog={closeDialog}
              // parentTenantId={this.state.parentTenantId}

              // offeringCustomer={(this.props.ecommerceCustData && this.props.ecommerceCustData.partyId) ? this.props.ecommerceCustData.partyId : this.state.offeringCustomer}
              // offeringCustomer={(this.props.ecommerceCustData && this.props.ecommerceCustData.partyId) ? [this.props.ecommerceCustData.partyId] : this.state.offeringCustomersList}
              />
            </DialogContent>
          </Dialog>
        )}

        {showNewCustomer && (
          <Dialog
            maxWidth={"lg"}
            PaperComponent={DraggableDialogPaper}
            fullWidth={true}
            open={showNewCustomer}
            aria-labelledby="import-dialog-title"
          >
            <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
              {t("ADD_NEW_CUSTOMER")}
            </DialogTitle>
            <DialogContent dividers>
              <CustomerDetails
                manageCustomer={true}
                close={removeCustomerForm}
                addCustomer={addCustomer}
                validator={closeErrorMessage}
                customerDetails={newCustomerDetails}
              />
            </DialogContent>
          </Dialog>
        )}
      </div>
      <Loader loading={loading} />
    </div>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

const mapStateToProps = (state) => {
  return {
    providerType: state.auth.providerType,
    userPerms: state.auth.userPerms,
    loggedInUserType: state.auth.userLoginType,
    quoteEnabled: state.auth.quoteEnabled,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(AddonsTable));
